// extracted by mini-css-extract-plugin
export default {"wrapper":"List_wrapper__Ha9Mn","operationArea":"List_operationArea__LMbdU","modal":"List_modal__IPDll","image":"List_image__jRdXp"};